import { defineMessages } from "react-intl";
import { node as ama } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/ama";
import { node as ana } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/ana";
import { node as antiCardiolipinAt } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/antiCardiolipinAt";
import { node as cryoglobulin } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/cryoglobulin";
import { node as immunElfo } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/immunElfo";
import { node as lkm } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/lkm";
import { node as pAnca } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/pAnca";
import { node as sma } from "src/modules/ltx/forms/phase-i/lab-procedures/autoimmun-lab-procedures/sma";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.autoimmun_lab_procedures",
		defaultMessage: "Autoimmun laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "autoimmunLabProcedures",
	value: { type: "list", title: messages.title, columns: 2 },
	children: [
		ama,
		ana,
		antiCardiolipinAt,
		cryoglobulin,
		immunElfo,
		lkm,
		pAnca,
		sma
	]
};
